/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a GeoPoint
 * @export
 * @interface GeoPoint
 */
export interface GeoPoint {
    /**
     * Geopoint latitude
     * @type {number}
     * @memberof GeoPoint
     */
    latitude?: number;
    /**
     * Geopoint longitude
     * @type {number}
     * @memberof GeoPoint
     */
    longitude?: number;
}

/**
 * Check if a given object implements the GeoPoint interface.
 */
export function instanceOfGeoPoint(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GeoPointFromJSON(json: any): GeoPoint {
    return GeoPointFromJSONTyped(json, false);
}

export function GeoPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeoPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latitude': !exists(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !exists(json, 'longitude') ? undefined : json['longitude'],
    };
}

export function GeoPointToJSON(value?: GeoPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latitude': value.latitude,
        'longitude': value.longitude,
    };
}

